// UI strings for opening the next lesson early by a joint vote (Axel's decision of 2026-10-07;
// course/EarlyOpenVote.tsx, engine/src/course.ts earlyOpenOffer): asked on Oppitunnit's current week
// and on Tänään once both of you have passed the open lesson and the next one waits for its date.
// Finnish (default) and English side by side; en has the same shape.
// Style: docs/FINNISH-STYLE.md (sinä/te, no internal jargon, only actionable text). Names stay in the
// nominative (no guessing their inflection).
import { defineArea } from '../area';

export const earlyOpenFi = {
  /** The question, nobody has answered yet. */
  ask: (n: number) => `Avataanko oppitunti ${n} nyt?`,
  /** The partner said yes, you have not. */
  partnerAsks: (name: string, n: number) => `${name} haluaa avata oppitunnin ${n} nyt – sinä?`,
  /** You said yes, the partner has not answered. */
  youAsked: (n: number) => `Haluat avata oppitunnin ${n} nyt.`,
  waitsFor: (name: string) => `${name} ei ole vielä vastannut.`,
  /** What it means: its own date otherwise, and the new rhythm. */
  otherwise: (date: string) => `Muuten se avautuu ${date} – jos avaatte sen nyt, seuraava avautuu viikon päästä.`,
  yes: 'Kyllä, avataan',
  withdraw: 'Peru',
  /** Both said yes; the answer is on its way to the server. */
  opening: (n: number) => `Avataan oppitunti ${n}…`,
  /** For screen readers: the group's name. */
  label: (n: number) => `Oppitunnin ${n} avaaminen etuajassa`,
  /** Asetukset → the pace: the latest early opening and the rhythm since (0 = Sunday … 6 = Saturday). */
  paceOpened: (n: number, date: string, weekday: number) =>
    `Oppitunti ${n} avattiin etuajassa ${date} – siitä lähtien uusi oppitunti avautuu ${FI_WEEKDAYS_ADV[weekday] ?? ''}, kun olette molemmat läpäisseet edellisen.`,
};

/** "keskiviikkoisin": on that weekday, every week (0 = Sunday). */
const FI_WEEKDAYS_ADV = ['sunnuntaisin', 'maanantaisin', 'tiistaisin', 'keskiviikkoisin', 'torstaisin', 'perjantaisin', 'lauantaisin'];
const EN_WEEKDAYS = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];

const earlyOpenEn: typeof earlyOpenFi = {
  ask: (n) => `Open lesson ${n} now?`,
  partnerAsks: (name, n) => `${name} would like to open lesson ${n} now – you?`,
  youAsked: (n) => `You would like to open lesson ${n} now.`,
  waitsFor: (name) => `${name} has not answered yet.`,
  otherwise: (date) => `Otherwise it opens on ${date} – if you open it now, the next one opens a week from today.`,
  yes: 'Yes, open it',
  withdraw: 'Take it back',
  opening: (n) => `Opening lesson ${n}…`,
  label: (n) => `Opening lesson ${n} early`,
  paceOpened: (n, date, weekday) =>
    `Lesson ${n} was opened early on ${date} – since then a new lesson opens on ${EN_WEEKDAYS[weekday] ?? ''}, once you have both passed the one before.`,
};

// Messages.earlyOpen (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('earlyOpen', earlyOpenFi, earlyOpenEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof earlyOpenFi> {}
}
